import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import StudentService from "services/StudentService";

export const getStudentList = createAsyncThunk(
  "students/getStudentList",
  async (params, { rejectWithValue }) => {
    try {
      const response = await StudentService.getStudentList(params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch Student List"
      );
    }
  }
);
export const downloadStudentExcel = createAsyncThunk(
  "user/downloadStudentExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await StudentService.downalodStudentExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const statusUpdateStudent = createAsyncThunk(
  "classes/statusUpdateStudent",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StudentService.statusUpdateStudent(data);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Update Status"
      );
    }
  }
);

export const addStudent = createAsyncThunk(
  "students/addStudent",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await StudentService.addStudent(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Add Student"
      );
    }
  }
);
export const getSingleStudent = createAsyncThunk(
  "classes/getSingleStudent",
  async (params, { rejectWithValue }) => {
    try {
      const response = await StudentService.getSingleStudent(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch Student"
      );
    }
  }
);
export const updateStudent = createAsyncThunk(
  "classes/updateStudent",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await StudentService.updateStudent(data, params);
      return response;
    } catch (err) {
      console.error("Update error:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to update Student"
      );
    }
  }
);
export const updateBulkStudentsStatus = createAsyncThunk(
  "school/updateBulkStudentsStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await StudentService.updateBulkStuentsStatus(
        data,
        status
      );
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);
export const StudentsBulkDelete = createAsyncThunk(
  "school/StudentsBulkDelete",
  async (data, { rejectWithValue }) => {
    console.log(data);

    try {
      const response = await StudentService.studentBulkDelete(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);

export const downloadExcelFormat = createAsyncThunk(
  "students/downloadExcelFormat",
  async (
    { academicId, schoolId, classId, divisionId, students_count },
    { rejectWithValue }
  ) => {
    try {
      const response = await StudentService.downloadExcelFormat(
        academicId,
        schoolId,
        classId,
        divisionId,
        students_count
      );

      console.log("res", response);

      const contentDisposition = response.headers["content-disposition"];
      console.log("content-disposition", contentDisposition);

      let filename = "students.xlsx";

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename="?(.+?)"?(;|$)/i
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      return {
        blob: response.data,
        filename,
      };
    } catch (err) {
      return rejectWithValue(err.message || "Failed to download Excel Format");
    }
  }
);

export const studentBulkCreate = createAsyncThunk(
  "students/studentBulkCreate",
  async (
    { academicId, schoolId, classId, divisionId, data },
    { rejectWithValue }
  ) => {
    try {
      const blob = await StudentService.studentBulkCreate(
        academicId,
        schoolId,
        classId,
        divisionId,
        data
      );
      return blob;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to Upload Excel ");
    }
  }
);
export const getTempExcelData = createAsyncThunk(
  "classes/getTempExcelData",
  async ({ temp_table_name, params }, { rejectWithValue }) => {
    try {
      const response = await StudentService.getTempExcelData(
        temp_table_name,
        params
      );

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch Student"
      );
    }
  }
);
export const getStudentsBySchool = createAsyncThunk(
  "classes/getStudentsBySchool",
  async (params, { rejectWithValue }) => {
    try {
      const response = await StudentService.getStudentsBySchool(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch Student"
      );
    }
  }
);
export const finalizeTableData = createAsyncThunk(
  "classes/finalizeTableData",
  async (temp_table_name, { rejectWithValue }) => {
    try {
      const response = await StudentService.finalizeTableData(temp_table_name);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to finalize data"
      );
    }
  }
);
export const deleteTempTableData = createAsyncThunk(
  "classes/deleteTempTableData",
  async (temp_table_name, { rejectWithValue }) => {
    try {
      const response = await StudentService.deleteTempTableData(
        temp_table_name
      );

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to finalize data"
      );
    }
  }
);

const studentSlice = createSlice({
  name: "students",
  initialState: {
    students: {},
    singleStudent: {},
    studentsBychool: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get student
      .addCase(getStudentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStudentList.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload;
      })
      .addCase(getStudentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //excel
      .addCase(downloadStudentExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadStudentExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadStudentExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // update status
      .addCase(statusUpdateStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(statusUpdateStudent.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(statusUpdateStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // add student
      .addCase(addStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addStudent.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // get single Student
      .addCase(getSingleStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleStudent.fulfilled, (state, action) => {
        state.loading = false;
        state.singleStudent = action.payload;
      })
      .addCase(getSingleStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Student

      .addCase(updateStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateStudent.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // bulk status update student
      .addCase(updateBulkStudentsStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBulkStudentsStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBulkStudentsStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // delete selected students
      .addCase(StudentsBulkDelete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(StudentsBulkDelete.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(StudentsBulkDelete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //Download Excel Format
      .addCase(downloadExcelFormat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadExcelFormat.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadExcelFormat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //Upload temp Excel
      .addCase(studentBulkCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(studentBulkCreate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(studentBulkCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //get temp Excel data
      .addCase(getTempExcelData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTempExcelData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getTempExcelData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //finalizeTableData
      .addCase(finalizeTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(finalizeTableData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(finalizeTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //deleteTempTableData
      .addCase(deleteTempTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTempTableData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteTempTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //getStudentsBySchool
      .addCase(getStudentsBySchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStudentsBySchool.fulfilled, (state, action) => {
        state.loading = false;
        state.studentsBychool = action.payload;
      })
      .addCase(getStudentsBySchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default studentSlice.reducer;
